import script from "./RenderVNode.vue?vue&type=script&lang=js"
export * from "./RenderVNode.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__